import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

gsap.registerPlugin(ScrollTrigger);

export function useGsapScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    window.lenis = lenis;

    const onAnchor = (e) => {
      const a = e.target.closest("a[href^='#']");
      if (!a || a.getAttribute("href").length < 2) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (!el) return;
      e.preventDefault();
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      lenis.scrollTo(top, { duration: 1.4 });
    };
    document.addEventListener("click", onAnchor);

    const ctx = gsap.context(() => {
      document.querySelectorAll("[data-split='words']").forEach((el) => {
        if (el.dataset.splitDone) return;
        const text = el.textContent;
        el.innerHTML = text
          .split(/(\s+)/)
          .map((w) =>
            /\s+/.test(w)
              ? w
              : `<span class="gs-word" style="display:inline-block;overflow:hidden;vertical-align:bottom;"><span class="gs-inner" style="display:inline-block;">${w}</span></span>`
          )
          .join("");
        el.dataset.splitDone = "1";
        gsap.from(el.querySelectorAll(".gs-inner"), {
          yPercent: 110,
          opacity: 0,
          ease: "power3.out",
          duration: 0.7,
          stagger: 0.05,
          scrollTrigger: { trigger: el, start: "top 95%", once: true },
        });
      });

      document.querySelectorAll("[data-anim='up']").forEach((el) => {
        gsap.from(el, {
          y: 30,
          opacity: 0,
          duration: 0.7,
          ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 95%", once: true },
        });
      });

      document.querySelectorAll("[data-anim='parallax']").forEach((el) => {
        gsap.to(el, {
          y: -50,
          ease: "none",
          scrollTrigger: { trigger: el, start: "top bottom", end: "bottom top", scrub: true },
        });
      });

      document.querySelectorAll("[data-anim='ticker']").forEach((el) => {
        gsap.to(el, {
          xPercent: -20,
          ease: "none",
          scrollTrigger: { trigger: el, start: "top bottom", end: "bottom top", scrub: 1 },
        });
      });
    });

    const refresh = () => ScrollTrigger.refresh();
    window.addEventListener("load", refresh);
    const t = setTimeout(refresh, 1200);

    return () => {
      document.removeEventListener("click", onAnchor);
      clearTimeout(t);
      window.removeEventListener("load", refresh);
      ctx.revert();
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.lenis = null;
    };
  }, []);
}
